import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './assets/sass/style.scss';
import * as serviceWorker from './serviceWorker';

const rootElement = document.getElementById( 'root' );
if (rootElement?.hasChildNodes()) {
    ReactDOM.hydrate(<App />, rootElement);
} else {
    ReactDOM.render(<App />, rootElement);
}

// ReactDOM.render( <App />, document.getElementById( 'root' ) );

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
